interface PopupResponse {
  data: any;
  popup: Window | null;
}

export const OpenPopUp = (
  url: string,
  queryParams: Record<string, string>,
  width = 600,
  height = 800
): Promise<PopupResponse> => {
  return new Promise((resolve, reject) => {
    const queryString = new URLSearchParams(queryParams).toString();

    // Calculate the popup position
    const left = (window.screen.width - width) / 2;
    const top = (window.screen.height - height) / 2;

    const popup = window.open(
      `${url}?${queryString}`,
      "popupWindow",
      `width=${width},height=${height},left=${left},top=${top},scrollbars=yes`
    );

    if (!popup) {
      reject(new Error("Failed to open popup"));
      return;
    }

    const handleMessage = (event: MessageEvent) => {
      try {
        const data = JSON.parse(event.data);

        window.removeEventListener("message", handleMessage);
        resolve({ data, popup });
      } catch {
        window.removeEventListener("message", handleMessage);
        reject(new Error("Invalid data received from popup"));
      }
    };

    window.addEventListener("message", handleMessage);

    const pollPopupClosed = setInterval(() => {
      if (popup.closed) {
        clearInterval(pollPopupClosed);
        window.removeEventListener("message", handleMessage);
        reject(new Error("Popup was closed before returning data"));
      }
    }, 500);
  });
};
